module.exports = function(app) {
	'use strict';
	app.directive('eprSummary', function() {
		return {

			restrict: 'A',
			templateUrl: '_directives.employerTemplate.html/directives/employee/eprSummary',

			scope : {
				employee: '=eprSummary',
				editMode: '=?',
				printMode: '=?'

			},

			controller: [
				'$scope', '$rootScope', '$state', '$q', 'services', 'sessionData', 'options',
				'addFlowCommander', 'employee', 'eprSummaryModals', 'planAdmin', 'uncoveredDependentModal',
				'$filter', 'modal', 'eprProviderValidationHelper', '$timeout', 'coverageBuddy','coremetrics',
				function (
					$scope, $rootScope, $state, $q, services, sessionData, options,
					addFlowCommander, employee, eprSummaryModals, planAdmin, uncoveredDependentModal,
					$filter, modal, eprProviderValidationHelper, $timeout, coverageBuddy,coremetrics
				) {

					$scope.commander = addFlowCommander;
					$scope.entitlements = sessionData.entitlements;
					$scope.multiGroup = false;
					$scope.states = options.statesOfUSA;
					$scope.reportCodeGroups = coverageBuddy.getReportCodeGroups($scope.employee.data);
					$scope.isCobProcessed = false;
					if(sessionData.employerInfo.brandName == '6010' || sessionData.employerInfo.brandName == '6011' || sessionData.employerInfo.brandName == '6012') {
						$scope.isCobProcessed = employee.data.hasOwnProperty('isCOBDataProcessed') ? employee.data.isCOBDataProcessed : false;
					}
					$scope.isWY = sessionData.employerInfo.brandName === '6012' ? true : false;
                    if(sessionData.appConfig && sessionData.appConfig.SEP) {
                        $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
                        //sessionData.appConfig.SEP.booleanValue;
                    }
                    else {
                        $scope.hasSEP = false;
                    }
                    $scope.outSideOpen = false;
                    if($scope.hasSEP) {
                        services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                            function (response) {
                                if (response) {
                                    $scope.outSideOpen = response;
                                }
                            });
                    }


                    $scope.isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&(navigator.vendor.toLowerCase().indexOf("google") > -1));
                    $scope.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                    (function doTheDates() {
						$scope.asoValue = sessionData.entitlements.clientQualifiers.aso;
						$scope.today = new Date();
						$scope.dt1900 = new Date(1900, 1, 1);
						$scope.dt2500 = new Date(2500, 1, 1);
						$scope.todayPlus1 = new Date();
						$scope.todayPlus1.setDate($scope.todayPlus1.getDate()+1);
						$scope.todayPlus2 = new Date();
						$scope.todayPlus2.setDate($scope.todayPlus2.getDate()+1);

						$scope.arrCutOffDates = {
							'dtHireMin': $scope.dt1900,
							'dtHireMax': $scope.dt2500,
							'dtCovMin': $scope.dt1900,
							'dtCovMax': $scope.dt2500,
							'dtBirthMin': $scope.dt1900,                               // Just a floor value
							'dtBirthMax': $scope.today
						};
						//custom message
						$scope.strHireDateMaxViolation = 'Please enter valid Hire Date';
						$scope.strHireDateMinViolation = 'Please enter valid Hire Date';
						$scope.strCovDateMaxViolation = 'Please enter valid Cov Date';
						$scope.strCovDateMinViolation = 'Please enter valid Cov Date';
						$scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
						$scope.strDOBMinViolation = 'Please enter valid Date of Birth';

						$scope.$watch('employee.data.subscriber.hireDate', function(newValue) {
							if (newValue instanceof Date) {
								$scope.arrCutOffDates.dtCovMin = new Date(newValue);
								$scope.arrCutOffDates.dtCovMin.setDate(newValue.getDate()-1);
								var d1 =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
								d1.setDate(d1.getDate()+1);
								$scope.strCovDateMinViolation = 'Hire Date cannot be greater than coverage effective date';

								$scope.arrCutOffDates.dtBirthMax = new Date(newValue);
								$scope.arrCutOffDates.dtBirthMax.setDate(newValue.getDate()+1);
								var d2 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
								d2.setDate(d2.getDate() -1);
								$scope.strDOBMaxViolation = 'Hire date cannot be earlier than the birth date. Please enter a valid hire date ';
							}
							else {
								if ($scope.employee.data.subscriber.birthDate instanceof Date) {
									$scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.birthDate);
									$scope.arrCutOffDates.dtCovMin.setDate($scope.employee.data.subscriber.birthDate.getDate() - 1);
									var d3 =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
									d3.setDate(d3.getDate()+1);
									$scope.strCovDateMinViolation = 'Member effective date is before their date of birth. Please enter a valid date of birth. ';
								}
								else {
									$scope.arrCutOffDates.dtCovMin = $scope.dt1900;
									var d4 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
									d4.setDate(d4.getDate()-2);
									$scope.strCovDateMinViolation = 'Coverage Date has to be more than 1/1/1900';
								}

								if ($scope.employee.data.subscriber.globalCoverageEffectiveDate instanceof Date) {
									$scope.arrCutOffDates.dtBirthMax = new Date($scope.employee.data.subscriber.globalCoverageEffectiveDate);
									$scope.arrCutOffDates.dtBirthMax.setDate($scope.employee.data.subscriber.globalCoverageEffectiveDate.getDate() + 1);
									var d5 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
									d5.setDate(d5.getDate());
									$scope.strDOBMaxViolation = 'Date of birth has be less than Coverage effective date';
								}
								else {
									$scope.arrCutOffDates.dtHireMax = $scope.dt2500;
									var d6 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
									d6.setDate(d6.getDate()-2);
									$scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
								}

							}
							if ($scope.arrCutOffDates.dtBirthMax > $scope.todayPlus1) {
								$scope.arrCutOffDates.dtBirthMax = $scope.todayPlus1;
								var d7 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
								d7.setDate(d7.getDate());
								$scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
							}
						});
					}());


					(function doTheSections() {
						$scope.expand = {
							subscriberInfo: true,
							dependents: true,
							planCoverage: true,
							otherInsurance: true,
							medicare: true,
							tobacco: true,
							reportCodes: true,
							mnloa: true,
							providers: true
						};

						$scope.setExpansions = function(open) {
							Object.keys($scope.expand).forEach(function(expansion) {
								$scope.expand[expansion] = open;
							});
						};

						$scope.hasParticipantsWithProviders = coverageBuddy.hasParticipantsWithProviders;

						$scope.$watch('employee.data', function() {
							$scope.showMNLOA = addFlowCommander.isMNLOARequired($scope.employee);
							$scope.showOtherInsurance = addFlowCommander.isOtherInsuranceRequired($scope.employee, true);
							$scope.showMedicare = addFlowCommander.isMedicareRequired($scope.employee);
							$scope.isOtherInsuranceProcessed =  !employee.data.isCOBDataProcessed;//Changes for WYRFS-312
						}, true);
					}());


					(function doTheGroupSwitcher() {
						$scope.getCoverageActiveStr = function(groupNum) {
							var coverage = coverageBuddy.getCoveragesByGroupNumber($scope.employee.data.subscriber, groupNum)[0];
							if (coverage) {
								var status = "Cancelled";
								coverage.memberLobs.forEach(function(lob) {
									if (!lob.coverageEndDate || new Date(lob.coverageEndDate) > new Date()) {
										status = "Active";
									}
								});
								return status;
							} else {
								return "Error";
							}
						};

						var isCoverageActive = function(cov) {
							var status = false;
							if (Array.isArray(cov.memberLobs)) {
								cov.memberLobs.forEach(function(lob) {
									if (!lob.coverageEndDate) {
										status = true;
									}
								});
							}
							return status;
						};
						$scope.viewOtherInsuranceCoremetrics = function(){
							coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:VIEW OTHER INSURANCE HISTORY','EMPLOYERS:ENROLLMENT');
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:VIEW SUBSCRIBER SUMMARY','EMPLOYERS:ENROLLMENT');
						}
						$scope.planCoverageCoremetrics = function(){
							coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:VIEW PLAN COVERAGE HISTORY','EMPLOYERS:ENROLLMENT');
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:VIEW SUBSCRIBER SUMMARY','EMPLOYERS:ENROLLMENT');
						}
						$scope.viewReportCoremetrics =function(){
							coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:VIEW REPORT CODE HISTORY','EMPLOYERS:ENROLLMENT');
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:VIEW SUBSCRIBER SUMMARY','EMPLOYERS:ENROLLMENT');
						}


						$scope.switcherOptions = (function(coverages) {
									var switcherOptionsActive = [];
									var switcherOptionsCancelled = [];
									if (Array.isArray(coverages)) {
										coverages.forEach(function(coverage) {
											if (coverageBuddy.isGroupActive(coverage.groupNumber) && switcherOptionsActive.indexOf(coverage.groupNumber) < 0) {
												switcherOptionsActive.push(coverage.groupNumber);
											}
											else if (switcherOptionsCancelled.indexOf(coverage.groupNumber) < 0) {
												switcherOptionsCancelled.push(coverage.groupNumber);
											}
										});
									}
									var lowToHigh = function(a,b) { return a - b; };
									switcherOptionsActive.sort(lowToHigh);
									switcherOptionsCancelled.sort(lowToHigh);
									return switcherOptionsActive.concat(switcherOptionsCancelled);
								}(employee.data.subscriber.memberCoverages));

								$scope.multiGroup = $scope.switcherOptions.length > 1;
								$scope.groupSwitcher = { selection: $scope.switcherOptions[0] };

                        $scope.$watch('employee.data.subscriber.memberCoverages', function(n, o) {
                            if (Array.isArray(n)) {

                                $scope.switcherOptions = (function(coverages) {
                                    var switcherOptionsActive = [];
                                    var switcherOptionsCancelled = [];
                                    if (Array.isArray(coverages)) {
                                        coverages.forEach(function(coverage) {
                                            if (coverageBuddy.isGroupActive(coverage.groupNumber) && switcherOptionsActive.indexOf(coverage.groupNumber) < 0) {
                                                switcherOptionsActive.push(coverage.groupNumber);
                                            }
                                            else if (switcherOptionsCancelled.indexOf(coverage.groupNumber) < 0) {
                                                switcherOptionsCancelled.push(coverage.groupNumber);
                                            }
                                        });
                                    }
                                    var lowToHigh = function(a,b) { return a - b; };
                                    switcherOptionsActive.sort(lowToHigh);
                                    switcherOptionsCancelled.sort(lowToHigh);
                                    return switcherOptionsActive.concat(switcherOptionsCancelled);
                                }(n));

                                $scope.multiGroup = $scope.switcherOptions.length > 1;
                                if($state.params.edit === true) {
                                    $scope.groupSwitcher = { selection: $scope.switcherOptions[0] };
                                }
                            }
                        });

					}());


					(function doTheEditPermissions() {
						$scope.setEditPermissions = function(gn) {
							return planAdmin.canModifyGroupNumber(gn);
						};
						$scope.$watch('groupSwitcher.selection', function(newSelection) {
							if (newSelection) {
								$scope.setEditPermissions(newSelection);
								$scope.productEffectiveDate = services.eprsvc.additionalGroupInformation().getEffectiveDate($scope.groupSwitcher.selection);
								services.eprsvc.additionalGroupInformation({ groupNumber: $scope.groupSwitcher.selection }).fetch($scope.productEffectiveDate).then(
									function(response) {
										var p = (response && response.data && response.data.payload) || {};
                                        //RF1308194 added the additional parent checks.
										$scope.tobaccoQuestionRequired = response && response.data && response.data.payload && response.data.payload.tobaccoQuestionRequired;
										$scope.additionalGroupInformation = p;
										$rootScope.$broadcast('updateTobaccoStatuses');
                                        $rootScope.$broadcast('updateProvidersonRevert');
										var coverage = coverageBuddy.getCoveragesByGroupNumber($scope.employee.data.subscriber, newSelection)[0];
										var activeMedical = false;
										if (coverage) {
											coverage.memberLobs.forEach(function(lob) {
												if (lob.coverageType && lob.coverageType.toLowerCase && lob.coverageType.toLowerCase() == "medical") {
													if (!lob.coverageEndDate || new Date(lob.coverageEndDate) > new Date()) {
														activeMedical = true;
													}
												}
											});
										}

										$scope.currentGroupCanHaveProviders = activeMedical && (
											p.physicianOfRecord ||
											p.providerRequired ||
											p.primaryCarePhysician
										);
									},
									function() { }
								);
							}
						});
					}());


					(function doTheModals() {
						var umi = $state.params.umi;
						var metadata = $scope.employee.metadata;
						var groupSwitcher = $scope.groupSwitcher;
						var esm = eprSummaryModals;
						$scope.viewMedicareHistory = esm.viewMedicareHistory(umi, groupSwitcher, $scope.$new(), metadata);
						$scope.viewOtherInsuranceHistory = esm.viewOtherInsuranceHistory(umi, groupSwitcher, $scope.$new(), metadata);
						$scope.viewOtherInsuranceAndMedicareHistory = esm.viewOtherInsuranceAndMedicareHistory(umi, groupSwitcher, $scope.$new(), metadata);
						$scope.viewPlanCoverage = esm.viewPlanCoverage(umi, groupSwitcher, $scope.$new(), metadata);
						$scope.viewProviderModal = esm.viewProviderModal(umi, groupSwitcher, $scope.$new(), metadata);
						$scope.viewReportCodeHistory = esm.viewReportCodeHistory(umi, groupSwitcher, $scope.$new(), metadata);
					}());


					(function doTheAddCoverage() {
						$scope.goToAddCoverage = function(){
							coremetrics.startConversion('EMPLOYERS:ENROLLMENT:ADD COVERAGE','EMPLOYERS: ENROLLMENT');
							coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE','EMPLOYERS: ENROLLMENT');
							$state.go('employee.find.addCoverage');
						};

						var deferred;
						var reportCodesValidatedHandler;
						var providerValidatedHandler;
						$scope.presaveHook = function() {
							deferred = $q.defer();
							if (deletingLobsWithoutAddition($scope.employee)) {
								deferred.reject();
								var prettyName = $filter('capitalize')($scope.employee.data.subscriber.fullName.first) + ' ' +
									$filter('capitalize')($scope.employee.data.subscriber.fullName.last);
								var message = 'Please ensure to add coverage for ' +
									prettyName +
									'. You will not be able to save the changes without adding new coverage. ' +
									'If you wish to cancel coverage, please use cancel coverage link.';
								$scope.modalContent = {
									header: 'WARNING',
									message: message
								};
								modal.open({
									template: require('pages/employee/modals/genericInfoModal.html'),
									scope: $scope
								});
								return deferred.promise;
							}

							updateNewMemberEffectiveDates($scope.employee.data);

							removeProductsMarkedForDeletion($scope.employee);
							correctAllCoverageCategoryCodes($scope.employee.data);

							checkDependentsForCoverage().then(
								function() {
									$scope.$broadcast('assignAct4');

                                    $scope.$broadcast('assignTobacco');

									eprProviderValidationHelper.count = 0;
									eprProviderValidationHelper.failed = 0;
									eprProviderValidationHelper.success = 0;
									var providerDeferred = $q.defer();
									if (providerValidatedHandler) { providerValidatedHandler(); } // deregister existing listener
									providerValidatedHandler = $scope.$on('providerValidated', function(/* event, validationSucceeded */) {
										if (eprProviderValidationHelper.count == eprProviderValidationHelper.failed + eprProviderValidationHelper.success) {
											if (eprProviderValidationHelper.failed == 0) {
												providerDeferred.resolve();
											}
											else {
												providerDeferred.reject();
											}
										}
									});
									$scope.$broadcast('validateProvider');
									if (reportCodesValidatedHandler) { reportCodesValidatedHandler(); } // deregister existing listener
									reportCodesValidatedHandler = $scope.$on('reportCodesValidated', function(event, isSuccessful) {
										console.debug('heard reportCodesValidated', isSuccessful);
										if (isSuccessful) {
											providerDeferred.promise.then(function() {
												// Report codes good, providers good, submit the form, but first add in provider data
												$scope.$broadcast('assignProvider');
												$timeout(function() {
													deferred.resolve();
												}, 100);
											}, function() {
												deferred.reject('invalid providers');
											});
											// Hack to trigger save flow if no providers need validated.  Timeout for a bit, the simulate a provider validation
											// This should work because by the time the timeout executes, the providers should be trying to validate, so the count
											// should be > 0
											$timeout(function() {
												if (eprProviderValidationHelper.count == eprProviderValidationHelper.failed + eprProviderValidationHelper.success) {
													if (eprProviderValidationHelper.failed == 0) {
														providerDeferred.resolve();
													}
													else {
														providerDeferred.reject();
													}
												}
											}, 100);
										}
										else {
											deferred.reject('invalid report codes');
										}
									});
									$scope.$broadcast('validateReportCodes');
								},
								function() { deferred.reject('lol nah'); }
							);
							return deferred.promise;
						};

						function deletingLobsWithoutAddition(employeeObj) {
							var isSaveIllegal = false;
							if (employeeObj.isActive() &&
								Array.isArray(employeeObj.coverages.forDeletion) &&
								Array.isArray(employeeObj.coverages.forAddition))
							{
								isSaveIllegal = employeeObj.coverages.forDeletion.length > 0 && employeeObj.coverages.forAddition.length === 0;
							}
							return isSaveIllegal;
						}

						function checkDependentsForCoverage() {
							var dependentCheckDeferred = $q.defer();
							if ($scope.employee.data.dependents.some(function(d) { return d.memberCoverages.length === 0; })) {
								uncoveredDependentModal.launch($scope.employee.data, $rootScope.$new(), dependentCheckDeferred);
							}
							else { dependentCheckDeferred.resolve(); }
							return dependentCheckDeferred.promise;
						}

						var today = new Date();
						today.setHours(0);
						today.setMinutes(0);
						today.setSeconds(0);
						today.setMilliseconds(0);

						function updateNewMemberEffectiveDates(data) {
							var action = function(lob, blah, groupNumber) {
								if (lob.coverageEffectiveDate === 'updateMe') {
									lob.coverageEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;

									[$scope.employee.data.subscriber].concat($scope.employee.data.dependents).forEach(function(p) {
										var filteredCov = coverageBuddy.getCoveragesByGroupNumber(p, groupNumber);
										if(filteredCov.length) {
                                            filteredCov[0].memberLobs.filter(function (l) {
                                                return Boolean(
                                                    l.coverageType &&
                                                    l.coverageType.toUpperCase &&
                                                    l.coverageType.toUpperCase() === lob.coverageType &&
                                                    l.lineOfBusiness &&
                                                    l.lineOfBusiness.toUpperCase &&
                                                    l.lineOfBusiness.toUpperCase() === lob.lineOfBusiness
                                                );
                                            }).filter(function (l) {
                                                return Boolean(
                                                    (!l.cancellationDate || l.cancellationDate > lob.coverageEffectiveDate) &&
                                                    (l.coverageEffectiveDate <= today && lob.coverageEffectiveDate > l.coverageEffectiveDate)
                                                );
                                            }).forEach(function (l) {
                                                l.coverageEffectiveDate = lob.coverageEffectiveDate;
                                            });
                                        }
                                        else {
											return;
										}
									});
								}
							};
							coverageBuddy.goThroughSubscriberLobsAndDo(data, action);
							coverageBuddy.goThroughDependentsLobsAndDo(data, action);
						}

						function removeProductsMarkedForDeletion(employeeObj) {
							if (employeeObj.isActive() && Array.isArray(employeeObj.coverages.forDeletion)) {
								employeeObj.coverages.forDeletion.forEach(function(obj) {
									var remove = function(lob, index, groupNum) {
										if (obj.groupNumber === groupNum && obj.lineOfBusiness === lob.lineOfBusiness) {
											lob.cancelReasonCode = obj.cancelReasonCode;
											lob.coverageEndDate = obj.cancelDate;
										}
									};
									coverageBuddy.goThroughSubscriberLobsAndDo(employeeObj.data, remove);
									coverageBuddy.goThroughDependentsLobsAndDo(employeeObj.data, remove);
								});
							}
						}

						function correctAllCoverageCategoryCodes(data) {
							var uniqueProducts = [];
							var today = new Date();
							var productEnrolleeTemplate = {
								groupNumber: '',
								lineOfBusiness: '',
								subscriber: true,
								spouse: false,
								domesticPartner: false,
								depCount: 0,
								ccc: null
							};
							//establish all unique products on the subscriber level
							coverageBuddy.goThroughSubscriberLobsAndDo(data, function(lob, index, groupNum) {
								productEnrolleeTemplate.groupNumber = groupNum;
								productEnrolleeTemplate.lineOfBusiness = lob.lineOfBusiness;
								uniqueProducts.push(angular.copy(productEnrolleeTemplate));
							});
							//go through all dependents and determine who's all enrolled
							coverageBuddy.goThroughDependentsLobsAndDo(data, function(depLob, depIndex, groupNum) {
								//find our matching product
								uniqueProducts.forEach(function(uniProd) {
									if (uniProd.groupNumber === groupNum && uniProd.lineOfBusiness === depLob.lineOfBusiness) {
										//if they're enrolled, check relationship to determine Cov. Category Code
										if (uniProd && (!depLob.coverageEndDate || depLob.coverageEndDate > today) && !depLob.cancelReasonCode) {
											if (data.dependents[depIndex].relationshipCode === '01') { //spouse #
												uniProd.spouse = true;
											} else if (data.dependents[depIndex].relationshipCode === '29') { //dom. partner #
												uniProd.domesticPartner = true;
											} else { //any other code all means the same thing - a dependent
												uniProd.depCount++;
											}
										}
									}
								});
							});
							//establish coverage category code for each product
							uniqueProducts.forEach(function(productEnrollees) {
								productEnrollees.ccc = coverageBuddy.getCoverageCategoryCode(productEnrollees.subscriber,
									productEnrollees.spouse, productEnrollees.domesticPartner, productEnrollees.depCount);
							});
							//put corresponding coverage category code on all lines of business
							var assignCCC = function(lob, index, groupNum) {
								uniqueProducts.forEach(function(uniProd) {
									if (uniProd.groupNumber === groupNum && uniProd.lineOfBusiness === lob.lineOfBusiness) {
										lob.coverageCategoryCode = uniProd.ccc;
									}
								});
							};
							coverageBuddy.goThroughSubscriberLobsAndDo(data, assignCCC);
							coverageBuddy.goThroughDependentsLobsAndDo(data, assignCCC);
						}
					}());


					(function doThePrintMode(employee) {
						if(sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator){
							$scope.employerName = sessionData.employerInfo.planAdministrator.company;
						}
						//$scope.find = (window.location.href.indexOf('print=true')!= -1);
						$scope.isDependentHasMedicare = false;
						$scope.subscriberProviders = [];
						$scope.subscriberTobaccos = [];
						$scope.dependentProviders = [];
						$scope.dependentTobaccos = [];
						$scope.dpnsOthIns = [];
						$scope.subscriberReportCodes = [];
						$scope.dependentReportCodes = [];
						$scope.subscriberCoverages = [];
						$scope.dependentCoverages = [];

						if(employee){
							if(employee.data && employee.data.dependents) {
								for (var i = 0; i < employee.data.dependents.length; i++) {
									if (employee.data.dependents[i].medicareEligibleIndicator == 'yes') {
										$scope.isDependentHasMedicare = true;
										break;
									}
								}
							}

							$scope.subscriberProvider = {
								groupNumber: '',
								providerID: '',
								providerName:''
							};

							$scope.subscriberTobacco = {
								groupNumber: '',
								tobaccoStatus: '',
								tobaccoEffectiveBeginDate:'',
								tobaccoEffectiveEndDate:''
							};
							if(employee.data && employee.data.subscriber) {
								var subCoverages = employee.data.subscriber.memberCoverages;
								if(subCoverages){
									for (var i = 0; i < subCoverages.length; i++) {
										$scope.subscriberProvider = {};
										$scope.subscriberProvider.groupNumber  = subCoverages[i].groupNumber;
										if(subCoverages[i].providerInformation) {
											$scope.subscriberProvider.providerID = subCoverages[i].providerInformation.physicianNumber;
											$scope.subscriberProvider.providerName = subCoverages[i].providerInformation.physicianName;
											$scope.subscriberProviders.push($scope.subscriberProvider);
										}
										$scope.subscriberTobacco = {};
										$scope.subscriberTobacco.groupNumber  = subCoverages[i].groupNumber;
										if(subCoverages[i].tobaccoStatus) {
											$scope.subscriberTobacco.tobaccoStatus = subCoverages[i].tobaccoStatus;
											$scope.subscriberTobacco.tobaccoEffectiveBeginDate = subCoverages[i].tobaccoEffectiveBeginDate;
											$scope.subscriberTobacco.tobaccoEffectiveEndDate   = subCoverages[i].tobaccoEffectiveEndDate;
											$scope.subscriberTobaccos.push($scope.subscriberTobacco);
										}
									}
								}
							}


							$scope.dependentProvider = {
								name:'',
								groupNumber: '',
								providerID: '',
								providerName:''
							};

							$scope.dependentTobacco = {
								name:'',
								groupNumber: '',
								tobaccoStatus: '',
								tobaccoEffectiveBeginDate:'',
								tobaccoEffectiveEndDate:''
							};
							if(employee.data) {
								var dpntCoverages = employee.data.dependents;
								$scope.dependentProvider = {};
								$scope.dependentTobacco = {};
								if(dpntCoverages){
									for (var i = 0; i < dpntCoverages.length; i++) {
										if(dpntCoverages[i].fullName.middle){
											$scope.dependentProvider.name = dpntCoverages[i].fullName.first +' '+ dpntCoverages[i].fullName.middle + ' ' + dpntCoverages[i].fullName.last;
											$scope.dependentTobacco.name  = dpntCoverages[i].fullName.first +' '+ dpntCoverages[i].fullName.middle + ' ' + dpntCoverages[i].fullName.last;
										}
										else{
											$scope.dependentProvider.name = dpntCoverages[i].fullName.first + ' ' + dpntCoverages[i].fullName.last;
											$scope.dependentTobacco.name  = dpntCoverages[i].fullName.first +' ' + dpntCoverages[i].fullName.last;
										}
										if(dpntCoverages[i].memberCoverages){
											for(var j = 0; j < dpntCoverages[i].memberCoverages.length; j++) {
												$scope.dependentProvider.groupNumber = dpntCoverages[i].memberCoverages[j].groupNumber;
												$scope.dependentTobacco.groupNumber  = dpntCoverages[i].memberCoverages[j].groupNumber;
												if(dpntCoverages[i].memberCoverages[j].providerInformation) {
													$scope.dependentProvider.providerID = dpntCoverages[i].memberCoverages[j].providerInformation.physicianNumber;
													$scope.dependentProvider.providerName = dpntCoverages[i].memberCoverages[j].providerInformation.physicianName;
													$scope.dependentProviders.push($scope.dependentProvider);
													$scope.dependentProvider = {};
												}
												if(dpntCoverages[i].memberCoverages[j].tobaccoStatus) {
													$scope.dependentTobacco.tobaccoStatus = dpntCoverages[i].memberCoverages[j].tobaccoStatus;
													$scope.dependentTobacco.tobaccoEffectiveBeginDate = dpntCoverages[i].memberCoverages[j].tobaccoEffectiveBeginDate;
													$scope.dependentTobacco.tobaccoEffectiveEndDate   = dpntCoverages[i].memberCoverages[j].tobaccoEffectiveEndDate;
													$scope.dependentTobaccos.push($scope.dependentTobacco);
													$scope.dependentTobacco = {};
												}
											}
										}
									}
								}
							}


							$scope.othInsHdgs = ['Subscriber/ Dependent Name','Name of Insurance Carrier','Policy Number','Group Number',
								'Effective Date', 'Cancel Date', 'Policy Holder Legal Name','Policy Holder Relation to Employee',
								'Policy Holder Birth Date', 'Policy Holder Employment Status', 'Policy Holder Retirement Date',
								'Custody','Parent w/Primary Medical Responsibility','Dependent Information Court Order'];
							$scope.subOthIns = {'1': '1'};
							if(employee.data && employee.data.subscriber && employee.data.subscriber.otherInsurance){
								$scope.subOthIns['Subscriber/ Dependent Name'] = $filter('capitalize')(employee.data.subscriber.fullName.first) +' '+ $filter('capitalize')(employee.data.subscriber.fullName.middle)+ ' ' + $filter('capitalize')(employee.data.subscriber.fullName.last);
								$scope.subOthIns['Name of Insurance Carrier']  = employee.data.subscriber.otherInsurance.insuranceCarrier;
								$scope.subOthIns['Policy Number']              = employee.data.subscriber.otherInsurance.policyNumber;
								$scope.subOthIns['Group Number']               = employee.data.subscriber.otherInsurance.groupNumber;
								$scope.subOthIns['Effective Date']             = filter(employee.data.subscriber.otherInsurance.effectiveDate);
								$scope.subOthIns['Cancel Date']                = filter(employee.data.subscriber.otherInsurance.cancelDate);
								$scope.subOthIns['Policy Holder Legal Name']   = $filter('capitalize')(employee.data.subscriber.otherInsurance.policyHolderFirstName +' '+employee.data.subscriber.otherInsurance.policyHolderLastName);
								$scope.subOthIns['Policy Holder Relation to Employee']  = 'Self';
								$scope.subOthIns['Policy Holder Birth Date']   = filter(employee.data.subscriber.otherInsurance.policyHolderBirthDate);
								$scope.subOthIns['Policy Holder Employment Status']  = employee.data.subscriber.otherInsurance.policyHolderEmploymentStatus;
								$scope.subOthIns['Policy Holder Retirement Date']    = filter(employee.data.subscriber.otherInsurance.retirementDate);
								$scope.subOthIns['Custody']                    = employee.data.subscriber.otherInsurance.custody;
								$scope.subOthIns['Parent w/Primary Medical Responsibility']  = employee.data.subscriber.otherInsurance.medicalResponsibility;
								$scope.subOthIns['Dependent Information Court Order']        = employee.data.subscriber.otherInsurance.courtOrder;
							}


							$scope.dpnOthIns = {'1':'1'};
							if(employee.data && employee.data.dependents) {
								for (var i = 0; i < employee.data.dependents.length; i++) {
									if (employee.data.dependents[i].otherInsurance) {
										$scope.dpnOthIns = {};
										$scope.dpnOthIns['Subscriber/ Dependent Name'] = $filter('capitalize')(employee.data.dependents[i].fullName.first) + ' ' + $filter('capitalize')(employee.data.dependents[i].fullName.middle) + ' ' + $filter('capitalize')(employee.data.dependents[i].fullName.last);
										$scope.dpnOthIns['Name of Insurance Carrier'] = employee.data.dependents[i].otherInsurance.insuranceCarrier;
										$scope.dpnOthIns['Policy Number'] = employee.data.dependents[i].otherInsurance.policyNumber;
										$scope.dpnOthIns['Group Number'] = employee.data.dependents[i].otherInsurance.groupNumber;
										$scope.dpnOthIns['Effective Date'] = filter(employee.data.dependents[i].otherInsurance.effectiveDate);
										$scope.dpnOthIns['Cancel Date'] = filter(employee.data.dependents[i].otherInsurance.cancelDate);
										$scope.dpnOthIns['Policy Holder Legal Name'] = $filter('capitalize')(employee.data.dependents[i].otherInsurance.policyHolderFirstName + ' ' + employee.data.dependents[i].otherInsurance.policyHolderLastName);
										$scope.dpnOthIns['Policy Holder Relation to Employee'] = $filter('otherInsuranceRelationship')(employee.data.dependents[i].otherInsurance.relationSubscriber);
										$scope.dpnOthIns['Policy Holder Birth Date'] = filter(employee.data.dependents[i].otherInsurance.policyHolderBirthDate);
										$scope.dpnOthIns['Policy Holder Employment Status'] = employee.data.dependents[i].otherInsurance.policyHolderEmploymentStatus;
										$scope.dpnOthIns['Policy Holder Retirement Date'] = filter(employee.data.dependents[i].otherInsurance.retirementDate);
										$scope.dpnOthIns['Custody'] = employee.data.dependents[i].otherInsurance.custody;
										$scope.dpnOthIns['Parent w/Primary Medical Responsibility'] = employee.data.dependents[i].otherInsurance.medicalResponsibility;
										$scope.dpnOthIns['Dependent Information Court Order'] = employee.data.dependents[i].otherInsurance.courtOrder;
										$scope.dpnsOthIns.push($scope.dpnOthIns);
									}
								}
							}
							$scope.subscriberReportCode = {
								groupNumber: '',
								abbr:'',
								value:''
							};
							$scope.subscriberReportCode = {};
							if(employee.data && employee.data.subscriber){
								var scoverages = employee.data.subscriber.memberCoverages;
								if(scoverages){
									for (var i = 0; i < scoverages.length; i++) {
										if(scoverages[i].reportCodes){
											for (var j = 0; j < scoverages[i].reportCodes.length; j++) {
												$scope.subscriberReportCode.groupNumber = scoverages[i].groupNumber;
												$scope.subscriberReportCode.abbr = scoverages[i].reportCodes[j].abbreviatedType;
												$scope.subscriberReportCode.value = scoverages[i].reportCodes[j].value;
												$scope.subscriberReportCodes.push($scope.subscriberReportCode);
												$scope.subscriberReportCode = {};
											}
										}
									}
								}
							}

							if(employee.data){
								var depndents = employee.data.dependents;
								$scope.dependentReportCode = {
									name: '',
									groupNumber: '',
									abbr:'',
									value:''
								};
								$scope.dependentReportCode = {};

								if(depndents){
									for (var i = 0; i < depndents.length; i++) {
										if(depndents[i].memberCoverages){
											for (var j = 0; j < depndents[i].memberCoverages.length; j++) {
												if(depndents[i].memberCoverages[j].reportCodes){
													for (var k = 0; k < depndents[i].memberCoverages[j].reportCodes.length; k++) {
														$scope.dependentReportCode.name = $filter('capitalize')(depndents[i].fullName.first) + ' ' + $filter('capitalize')(depndents[i].fullName.middle) +' '+ $filter('capitalize')(depndents[i].fullName.last);
														$scope.dependentReportCode.groupNumber = depndents[i].memberCoverages[j].groupNumber;
														$scope.dependentReportCode.abbr  = depndents[i].memberCoverages[j].reportCodes[k].abbreviatedType;
														$scope.dependentReportCode.value = depndents[i].memberCoverages[j].reportCodes[k].value;
														$scope.dependentReportCodes.push($scope.dependentReportCode);
														$scope.dependentReportCode = {};
													}
												}
											}
										}
									}
								}
							}
						}
						services.eprsvc.cancelReasonCodes().fetch().then(
							function (response) {
								if (Array.isArray(response.data.payload)) {
									$scope.cancelCodeReasonMap = {1: '1'};
									response.data.payload.forEach(function (obj) {
										$scope.cancelCodeReasonMap[obj.value] = obj.label;
									});

									$scope.subscriberCoverage = {
										groupNumber: '',
										planArea: '',
										lineOfBusiness:'',
										coverageCategoryCode:'',
										coverageEffectiveDate:'',
										coverageEndDate:'',
										cancelReason:''
									};
									$scope.subscriberCoverage = {};
									if(employee && employee.data && employee.data.subscriber){
										var coverages = employee.data.subscriber.memberCoverages;
										if(coverages){
											for (var i = 0; i < coverages.length; i++) {
												if(coverages[i].memberLobs){
													for (var j = 0; j < coverages[i].memberLobs.length; j++) {
														$scope.subscriberCoverage.groupNumber = coverages[i].groupNumber;
														$scope.subscriberCoverage.planArea = coverages[i].memberLobs[j].enrollmentSourceCode;
														$scope.subscriberCoverage.lineOfBusiness = coverages[i].memberLobs[j].lineOfBusiness;
														$scope.subscriberCoverage.coverageCategoryCode = coverages[i].memberLobs[j].coverageCategoryCode;
														$scope.subscriberCoverage.coverageEffectiveDate = coverages[i].memberLobs[j].coverageEffectiveDate;
														$scope.subscriberCoverage.coverageEndDate = coverages[i].memberLobs[j].coverageEndDate;
														$scope.subscriberCoverage.cancelReason = $scope.cancelCodeReasonMap[coverages[i].memberLobs[j].cancelReasonCode];
														$scope.subscriberCoverages.push($scope.subscriberCoverage);
														$scope.subscriberCoverage = {};
													}
												}
											}
										}
									}
									if(employee.data){
										var dependents = employee.data.dependents;
										$scope.dependentCoverage = {
											name: '',
											groupNumber: '',
											planArea: '',
											lineOfBusiness: '',
											coverageCategoryCode: '',
											coverageEffectiveDate: '',
											coverageEndDate: '',
											cancelReason: ''
										};
										$scope.dependentCoverage = {};
										if(dependents){
											for (var i = 0; i < dependents.length; i++) {
												if(dependents[i].memberCoverages){
													for (var j = 0; j < dependents[i].memberCoverages.length; j++) {
														if(dependents[i].memberCoverages[j].memberLobs){
															for (var k = 0; k < dependents[i].memberCoverages[j].memberLobs.length; k++) {
																$scope.dependentCoverage.name = $filter('capitalize')(dependents[i].fullName.first) + ' ' + $filter('capitalize')(dependents[i].fullName.middle) + ' '+  $filter('capitalize')(dependents[i].fullName.last);
																$scope.dependentCoverage.groupNumber = dependents[i].memberCoverages[j].groupNumber;
																$scope.dependentCoverage.planArea = dependents[i].memberCoverages[j].memberLobs[k].enrollmentSourceCode;
																$scope.dependentCoverage.lineOfBusiness = dependents[i].memberCoverages[j].memberLobs[k].lineOfBusiness;
																$scope.dependentCoverage.coverageCategoryCode = dependents[i].memberCoverages[j].memberLobs[k].coverageCategoryCode;
																$scope.dependentCoverage.coverageEffectiveDate = dependents[i].memberCoverages[j].memberLobs[k].coverageEffectiveDate;
																$scope.dependentCoverage.coverageEndDate = dependents[i].memberCoverages[j].memberLobs[k].coverageEndDate;
																$scope.dependentCoverage.cancelReason = $scope.cancelCodeReasonMap[dependents[i].memberCoverages[j].memberLobs[k].cancelReasonCode];
																$scope.dependentCoverages.push($scope.dependentCoverage);
																$scope.dependentCoverage = {};
															}
														}
													}
												}
											}
										}
									}
									if(window.location.href.indexOf('print=true')!= -1){
										$scope.find = true;
										$scope.printMode = true;
										$scope.$emit('switchToPrintMode');
									}
								}
								else{
									$scope.cancelCodeReasonMap = null;
									if(window.location.href.indexOf('print=true')!= -1){
										$scope.find = true;
										$scope.printMode = true;
										$scope.$emit('switchToPrintMode');
									}
								}
							},
							function (error) {
								console.error('eprsvc.cancelReasonCodes().fetch() failed with:', error);
								$scope.cancelCodeReasonMap = null;
								if(window.location.href.indexOf('print=true')!= -1){
									$scope.find = true;
									$scope.printMode = true;
									$scope.$emit('switchToPrintMode');
								}
							}
						);

						function filter(dateInput){
							if(dateInput == null || dateInput == ''){
								return '';
							}
							var d = '';
							d = (dateInput.getMonth()+1) + '/' + dateInput.getDate() + '/' + dateInput.getFullYear();
							return d;
						}
					}($scope.employee));
				}
			]
		};
	});
};
